import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import VideoCard from "../components/VideoCard";
import PlatformButtons from "../components/PlatformButtons";
import { VideoCardSkeleton } from "../components/Skeleton";
import { container, item } from "../lib/motion";
import { Film } from "lucide-react";

const FILTERS = [
  { id: "all", label: "All" },
  { id: "facebook", label: "Facebook" },
  { id: "tiktok", label: "TikTok" },
];

export function EmptyVideos({ prefix }) {
  return (
    <motion.div variants={item} className="glass-card p-12 text-center" data-testid={`${prefix}-videos-empty`}>
      <Film className="w-8 h-8 text-[#4da6ff] mx-auto mb-5" strokeWidth={1.5} />
      <h3 className="font-head text-2xl font-light">Watch the latest on Facebook &amp; TikTok</h3>
      <p className="text-zinc-500 mt-3 font-light max-w-md mx-auto">Our newest reminders are posted on Facebook first, with short clips on TikTok. Tap below to watch them now.</p>
      <PlatformButtons prefix={`${prefix}-empty`} className="justify-center mt-8" />
    </motion.div>
  );
}

export default function Watch() {
  const [videos, setVideos] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/watch").then((r) => setVideos(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  const shown = filter === "all" ? videos : videos.filter((v) => v.platform === filter);

  return (
    <Layout glow="top">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 pb-24">
        <motion.div initial="hidden" animate="show" variants={container} className="mb-12">
          <motion.span variants={item} className="eyebrow">Watch More</motion.span>
          <motion.h1 variants={item} className="font-head text-4xl sm:text-5xl lg:text-6xl font-light mt-4 tracking-tight">Every reminder, in one place</motion.h1>
          <motion.p variants={item} className="text-zinc-500 mt-5 max-w-xl font-light text-lg">Short cinematic videos on discipline, identity, and healing. Tap any video to watch it on its original platform.</motion.p>
          <motion.div variants={item} className="mt-8"><PlatformButtons prefix="watch" /></motion.div>
        </motion.div>

        <div className="flex gap-2 mb-10 flex-wrap" data-testid="watch-filters">
          {FILTERS.map((f) => (
            <button key={f.id} onClick={() => setFilter(f.id)} data-testid={`watch-filter-${f.id}`}
              className={`px-5 py-2.5 rounded-full text-sm transition-colors ${filter === f.id ? "bg-white text-black" : "btn-glass text-zinc-300"}`}>
              {f.label}
            </button>
          ))}
        </div>

        <motion.div initial="hidden" animate="show" variants={container} key={filter}
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="watch-grid">
          {!loaded && [0, 1, 2].map((s) => <VideoCardSkeleton key={s} />)}
          {loaded && shown.map((v, i) => <VideoCard key={v.id} v={v} index={i} />)}
        </motion.div>
        {loaded && shown.length === 0 && <motion.div initial="hidden" animate="show" variants={container}><EmptyVideos prefix="watch" /></motion.div>}
      </div>
    </Layout>
  );
}
